import type { ContainerProps as MantineContainerProps } from '@mantine/core';
import { Container as MantineContainer } from '@mantine/core';

type ContainerProps = MantineContainerProps;

export const Container = (props: ContainerProps) => {
  return <MantineContainer {...props} />;
};
